import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link, Typography } from "@mui/material";

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const wordmark = (
    <Box
      ref={ref}
      component="div"
      role="img"
      aria-label="EngageCraft Fantasy Football"
      sx={{
        textAlign: "center",
        py: 1.5,
        px: 1,
        ...sx,
      }}
      {...other}
    >
      <Typography
        component="div"
        sx={{
          fontWeight: 800,
          fontSize: "1rem",
          lineHeight: 1.1,
          letterSpacing: 0.2,
          color: "text.primary",
        }}
      >
        EngageCraft
      </Typography>
      <Typography
        component="div"
        sx={{
          fontWeight: 600,
          fontSize: "0.7rem",
          lineHeight: 1.2,
          mt: 0.25,
          letterSpacing: 0.6,
          textTransform: "uppercase",
          color: "text.secondary",
        }}
      >
        Fantasy Football
      </Typography>
    </Box>
  );

  if (disabledLink) {
    return wordmark;
  }

  return (
    <Link
      to="/"
      component={RouterLink}
      sx={{
        textDecoration: "none",
        display: "flex",
        justifyContent: "center",
        width: "100%",
        "&:hover": { textDecoration: "none" },
      }}
    >
      {wordmark}
    </Link>
  );
});

export default Logo;
